import React from "react";

export const About = () => {
  return (
      <>
        <p></p>
        <h3>How does it work?</h3>
        <p>All you have to do is to draw a <a href="https://en.wikipedia.org/wiki/Polygon">polygon</a> on
        the map. You can either draw your own or search for e.g. neighbourhood. You can always adjust, remove and create
        a new polygon. Whenever your selected area is ready, hit <em>Generate route</em> button
        which will <em>quickly</em> generate your most optimal route!</p>

        <p>When your route is generated, you will see a map with the blueprint of your street network.
        then hit <em>Run the route</em> which animate your route.</p>

        <h3>Is it really the most optimal route?</h3>
        <p>Short answer is yes, it <em>should</em> be optimal, given that you visit every street at least once and it is the
        shortest among all possible routes. Longer answer, yes it is optimal and for sketch of the
        proof see <a href='/everystreet_algorithm.pdf'>theoretical summary</a> or <a href="https://github.com/matejker/everystreet">GitHub repo</a>. Even longer answer, yes it is optimal see the full
        proof in <a href="https://doi.org/10.1007/BF01580113">Matching, Euler tours and the Chinese postman</a> writen
        by Edmonds and Johnson in 1973.</p>

        <h3>Why I can't generate a larger area than 3km<sup>2</sup></h3>
        <p>Unfortunately, the #everystreet algorithm is pretty computationally heavy, so, in order to run it as a web app we had
        to limit it to 3km<sup>2</sup>. You can always split your town into smaller chunks and generate them piece by piece. If
        you really want to generate route for greater area you can run algorithm on your machine, see
        the <a href="https://github.com/matejker/everystreet">GitHub repo</a>.</p>

        <h3>Why does the algorithm ignore some streets within the selected area?</h3>
        <p>Brilliant question. However, the term <em>street</em> is ambiguous and in general is hard to define what is a
        street and what is not. Therefore, for simplicity, we consider all roads accessible by car starting and ending
        in a given area. To determine such roads, we use <em>OpenStreetMap</em> with layer <em>drive</em>.</p>
      </>
  );
}
